<template>
  <div class="p-3 grid-container">
    <ManageProfileCard class="mt-2" />
    <ResetPasswordCard class="mt-2" />
    <ManageDeliveryAddressCard class="mt-2" />
    <RecentCartOrderRequestsCard checkout-type="CartRequest" class="mt-2" />
    <RecentCartOrderRequestsCard checkout-type="CartOrder" class="mt-2" />
  </div>
</template>

<script>
import ManageDeliveryAddressCard from './components/ManageDeliveryAddressCard';
import ManageProfileCard from './components/ManageProfileCard';
import ResetPasswordCard from './components/ResetPasswordCard';
import RecentCartOrderRequestsCard from './components/RecentCartOrderRequestsCard';
export default {
  name: 'MyAccountView',
  components: { RecentCartOrderRequestsCard, ManageProfileCard, ManageDeliveryAddressCard, ResetPasswordCard },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
